module.exports = __webpack_public_path__ + "media/images/oficinas/paso_patria-5007121add7321cbe8053f65a3d83c17.jpg";